import { useState } from "react";

export default function PopupMessage({ orderId, onClose }) {
  const [copied, setCopied] = useState(false);

  function onCopyOrderID() {
    navigator.clipboard.writeText("orderId");
    setCopied(true);
    console.log("Order id copied:", copied);
    alert("Order ID copied to clipboard!");
    setTimeout(() => {
      setCopied(false);
    }, 2000); // Reset copied state after 2 seconds
  }
  return (
    <div className="popup-message-overlay">
      <div className="popup-message-box">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "30px",
            paddingBottom: "20px",
            paddingLeft: "5px",
          }}
        >
          <h2
            style={{ color: "green", fontWeight: "bold", fontFamily: "Arial" }}
          >
            Reservation Successful!
          </h2>
          <img
            src={require(`../assets/successful-icon.png`)}
            alt="successful_icon"
            style={{ width: "100px", height: "100px" }}
          />
          <p
            style={{
              color: "#7d3f26",
              fontWeight: "bold",
              fontFamily: "Cinzel",
              textAlign: "center",
            }}
          >
            Please save your Order ID below for your reference
          </p>
          <div style={{ display: "flex", flexDirection: "row", gap: "3px" }}>
            <span
              style={{
                color: "#a52a2a",
                fontWeight: "bold",
                fontFamily: "Cinzel",
                fontSize: "20px",
              }}
            >
              {orderId}
            </span>
            <button
              onClick={onCopyOrderID}
              style={{ background: "none", border: "none", cursor: "pointer" }}
            >
              <img
                src={require("../assets/copy_btn.png")}
                alt="Copy"
                style={{ width: "40px", height: "20px" }}
              />
            </button>
          </div>
          <p
            style={{
              color: "#7d3f26",
              fontWeight: "bold",
              fontFamily: "Arial",
              fontSize: "12px",
              width: "80%",
              textAlign: "center",
            }}
          >
            Please wait for a text or email for your confirmation of your
            booking. Thank you!
          </p>
        </div>

        <button
          onClick={onClose}
          className="main-form-btnDownload"
          style={{ width: "70%", margin: "0 auto", marginBottom: "20px" }}
        >
          Close
        </button>
      </div>
    </div>
  );
}
